<!-- 创建时间2023/06/21 10:57:51 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：上传逻辑 -->
<template>
  <yxt-tooltip :disabled="!disabled" :content="$t('pc_kng_courseware_tip_connect_to_server'/**无法连接到服务器，如需访问请联系管理人员，检查服务器是否启动 */)" placement="top">
    <span>
      <yxtbiz-upload
        v-if="showUpload"
        ref="bizUpload"
        :isBizMixDeploy="true"
        :isLocal="isPrivate"
        :localGroupId="`${isPrivate ? serverGroupId : ''}`"
        source="501"
        app-code="kng"
        :config-key="isHtmlAndScorm ? 'ZipConfigKey' : 'KnowledgeConfigKey'"
        module-name="knowledgefiles"
        function-name="files"
        icon-class="icon-upload"
        :fileType="specialFileType_ || specialFileType"
        :filters="isHtmlAndScorm ? '.zip' : filters"
        :files-filter="filesFilter"
        :files-added="filesAdded"
        :before-upload="beforeUpload"
        :on-network-speed="onNetworkSpeed"
        :on-progress="onProgress"
        :on-uploaded="onUploaded"
        :on-error="onError"
        :drag="drag"
        :disabled="disabled"
        md5
        :multipe="multiple"
      >
        <template v-if="$slots.default">
          <slot></slot>
        </template>
        <div v-else>
          <i class="yxt-icon-upload color-gray-7 font-size-32"></i>
          <div class="mt6 color-gray-10">{{ $t('pc_biz_upload_lbl_drag_new'/**拖拽或点击此处选择文件 */) }}</div>
          <div class="mt4 color-gray-6 standard-size-12">
            {{ isHtmlAndScorm ? $t('pc_biz_lbl_supportspecialkng2'/**支持：压缩文件，大小限制300M内 */,[this.htmlAndScormSize]) : (enableUploadZip ? $t('pc_biz_lbl_supportcommonkng2'/**支持：文档、图片、视频、音频、压缩文档 */) : $t('pc_biz_lbl_supportcommonkng'/**支持：文档、图片、视频、音频 */)) }}
          </div>
        </div>
      </yxtbiz-upload>
    </span>
  </yxt-tooltip>
</template>

<script>
import { KNG_FILE_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import {
  handleFileSize,
  restUploadTime
} from 'yxt-biz-pc/packages/select-kng/src/utils';
import { handleUploadFileSize } from '../../utils';
const docFileTypes = '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pps,.pdf';
const knowledgeFilters = {
  [KNG_FILE_TYPE.IMAGE]: '.jpg,.jpeg,.gif,.png,.bmp',
  [KNG_FILE_TYPE.WORD]: docFileTypes,
  [KNG_FILE_TYPE.ZIP]: '.zip,.rar',
  [KNG_FILE_TYPE.AUDIO]: '.w4v,.m4a,.wma,.wav,.mp3,.amr',
  [KNG_FILE_TYPE.VIDEO]: '.wmv,.mp4,.flv,.avi,.rmvb,.mpg,.mkv,.mov,.mts',
  [KNG_FILE_TYPE.EXCEL]: docFileTypes,
  [KNG_FILE_TYPE.SCORM]: '.zip,.rar',
  [KNG_FILE_TYPE.HTML]: '.zip,.rar',
  [KNG_FILE_TYPE.PPT]: docFileTypes,
  [KNG_FILE_TYPE.PDF]: docFileTypes
};
const defaultKnowledgeFilters = '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pps,.pdf,.jpg,.jpeg,.gif,.png,.bmp,.wmv,.mp4,.flv,.avi,.rmvb,.mpg,.mkv,.mov,.mts,.w4v,.m4a,.wma,.wav,.mp3,.amr';
export default {
  name: 'kng-upload',
  inject: ['getUploadLimitConfig', 'getEnableUploadZip', 'getModule'],
  props: {
    drag: {
      type: Boolean,
      default: true
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
    serverGroupId: {
      // 私有云存储时必传
      type: [String, Number],
      default: ''
    },
    specialUpload: { // 创建时是否是html和scorm上传
      type: Boolean,
      default: false
    },
    specialFileType: {// 创建时fileType: scorm 、html、''
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filters: defaultKnowledgeFilters,
      isReupload: false,
      showUpload: true,
      specialUpload_: false, // 编辑重新上传是否是scorm和html标记
      specialFileType_: '' // 编辑重新上传时的fileType：scorm和html标记
    };
  },
  computed: {
    enableUploadZip() {
      return this.getEnableUploadZip() && this.getModule() !== 'ulcd';
    },
    uploadLimitConfig() {
      return this.getUploadLimitConfig();
    },
    multiple() {
      return !this.isReupload && !this.specialUpload;
    },
    isHtmlAndScorm() {
      return this.specialUpload || this.specialUpload_;
    },
    htmlAndScormSize() {
      const fileType = this.specialFileType_ || this.specialFileType;
      const size = this.uploadLimitConfig[fileType] || 0;
      return handleUploadFileSize(size)[0];
    }
  },
  watch: {
    isPrivate() {
      this.showUpload = false;
      this.$nextTick(() => {
        this.showUpload = true;
      });
    },
    enableUploadZip: {
      immediate: true,
      handler(val) {
        if (val && this.filters === defaultKnowledgeFilters) {
          this.filters = defaultKnowledgeFilters + ',' + knowledgeFilters[KNG_FILE_TYPE.ZIP];
        }
      }
    }
  },
  created() {
    this.$root.$on('reupload', this.reupload);
    this.$root.$on('continueUpload', this.continueUpload);
  },
  beforeDestroy() {
    this.$root.$off('reupload', this.reupload);
    this.$root.$off('continueUpload', this.continueUpload);
  },
  methods: {
    continueUpload() {
      this.specialUpload_ = false;
      this.specialFileType_ = '';
      this.isReupload = false;
      this.filters = this.enableUploadZip ? defaultKnowledgeFilters + ',' + knowledgeFilters[KNG_FILE_TYPE.ZIP] : defaultKnowledgeFilters;
      this.$nextTick(() => this.$el.querySelector('input').click());
    },
    reupload(info) {
      if (this.disabled) {
        return this.$message.warning(this.$t('pc_kng_courseware_tip_connect_to_server'/** 无法连接到服务器，如需访问请联系管理人员，检查服务器是否启动 */));
      }
      this.isReupload = true;
      this.filters = knowledgeFilters[info.fileType];
      this.specialFileType_ = info.fileType;
      this.specialUpload_ = info.fileType === KNG_FILE_TYPE.SCORM || info.fileType === KNG_FILE_TYPE.HTML;
      this.showUpload = false;
      this.$nextTick(() => {
        this.showUpload = true;
        setTimeout(() => this.$el.querySelector('input').click(), 300);
      });
    },
    filesFilter(files) {
      // 单个上传直接提示拦截过滤，多个上传界面展示错误信息
      if (files.length === 1) {
        files = files.filter(file => {
          const lastPoint = file.name.lastIndexOf('.');
          const extension = file.name.substring(lastPoint);
          // 格式 ，大小
          const filters = this.isHtmlAndScorm ? '.zip' : this.filters;
          if (extension && filters.indexOf(extension.toLowerCase()) < 0) {
            this.$message.error(this.$t('pc_kng_upload_tip_file_type_no_match'/** 上传文件类型不符合要求！ */));
            return false;
          }
          const fileType = Object.keys(knowledgeFilters).find(key =>knowledgeFilters[key].includes(extension));
          const maxSize = this.isHtmlAndScorm ? this.uploadLimitConfig[this.specialFileType_ || this.specialFileType] : this.uploadLimitConfig[fileType];
          if (file.size / 1024 > maxSize) {
            this.$message.error(this.$t('pc_kng_relatedSetting_msg_filesizelimit', {val: handleUploadFileSize(file.size / 1024)[0]}));
            return false;
          }
          return true;
        });
      }
      if (files.length > this.max) {
        this.$message.error(this.$t('pc_kng_upload_tip_more_upload_info'/** 最多同时上传10个文件！ */));
      }
      return files.length > this.max ? files.splice(0, this.max) : files;
    },
    filesAdded(files) {
      const list = files.map(file => {
        return {
          fileType: ['image', 'doc'].includes(file.fileType) ? file.fileClass : file.fileType,
          fileSize: Math.ceil(file.size / 1024),
          fileName: file.name,
          platform: file.platform === 'tencent' ? 0 : 1,
          _uuid: file.uuid,
          _isReupload: this.isReupload,
          _status: 0,
          _percentage: 0,
          _fileType: file.fileType,
          _keyPath: file.keyPath
        };
      });
      if (this.isReupload) {
        this.$emit('reupload', list.length && list[0]);
      } else {
        this.$emit('add', list);
      }
    },
    beforeUpload(file) {},
    // 上传速度、剩余时间
    // bytes time 毫秒
    onNetworkSpeed(bytes, time, pending) {
      // handleFileSize
      // B/s
      const speed = parseInt(bytes / (time / 1000), 10);
      const [, size, unit] = handleFileSize(speed);
      const rest = restUploadTime((pending / bytes) * time);
      this.$emit('speed', { speed: `${size} ${unit}/s`, restTime: rest });
    },
    onProgress(file, progress) {
      this.$emit('update', {
        _uuid: file.uuid,
        _isReupload: file._isReupload,
        _status: 0,
        _percentage: parseInt(progress * 100, 10),
        _abort: file.abort,
        _keyPath: file.keyPath
      });
    },
    onUploaded(file) {
      this.$emit('update', {
        fileId: file.id,
        _uuid: file.uuid,
        _isReupload: file._isReupload,
        _percentage: 100,
        _keyPath: file.keyPath
      });
    },
    onError(error, file) {
      let msg;
      switch (error) {
        case 'oversize':
          msg = this.$t('pc_kng_relatedSetting_msg_filesizelimit', {val: handleUploadFileSize(file.size / 1024)[0]});
          break;
        case 'forbidden':
          msg = this.$t('pc_kng_upload_tip_file_type_no_match'/** 上传文件类型不符合要求！ */);
          break;
        case 'overlength':
          msg = this.$t('pc_biz_lbl_filenameoverlength'/** 文件名称超过200个字符，请删减后重新上传！ */);
          break;
        default:
          this.$message.error(this.$t('pc_kng_upload_tit_net_err'/** 由于您的网络状态不稳定导致文件上传失败，请删除此文件后重新上传 */));
          msg = this.$t('pc_biz_lbl_fileuploadfail'/** 上传失败，请删除此文件后重新上传！ */);
          break;
      }
      this.$emit('update', {
        _uuid: file.uuid,
        _isReupload: file._isReupload,
        _status: 1,
        _percentage: 100,
        _error: msg
      });
    }
  }
};
</script>